import React from "react";
import { getCartstore, getCountries, getCurrencies, getLanguages, getUserProfile, getInfo, } from "../../services/header/header";
import Constant from "../../utils/constant";
import HeaderNav from "./components/Nav";
import HeaderPageLet from "./components/PageLet";
import { Header, HeaderContainer } from "./styles";
class WebHeader extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            userName: "",
            cart: {
                totalLen: 0,
                totalPrice: "",
                items: [],
                currencySymbol: ""
            },
            countries: [],
            topCountries: [],
            userCountry: null,
            currencies: [],
            userCurrency: null,
            languages: [],
            userLanguage: {},
            lowPriceCountryPriceOff: ""
        };
        this.getUser = () => {
            getUserProfile({
                sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined
            }, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { user = 0 } = res.info || {};
                const userName = user.email ? user.email.split("@")[0] : user.user_id;
                this.setState({ userName });
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.getCart = () => {
            getCartstore({
                sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined
            }, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                var _a;
                const { total_results = 0, cart_items = [], codTipsRef, cart_totals = [] } = res.info || [];
                const cart = {
                    totalLen: total_results,
                    totalPrice: ((_a = cart_totals === null || cart_totals === void 0 ? void 0 : cart_totals[1]) === null || _a === void 0 ? void 0 : _a.price) || "0",
                    currencySymbol: (codTipsRef === null || codTipsRef === void 0 ? void 0 : codTipsRef.currencySymbol) || "",
                    items: cart_items
                };
                this.setState({ cart });
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.getCountry = () => {
            getCountries(null, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { countries = [], topCountries } = res.info || {};
                const userCountry = countries.find(item => (item === null || item === void 0 ? void 0 : item.countryIsoCode3) === Constant.country);
                this.setState({
                    countries,
                    topCountries,
                    userCountry
                });
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.getLanguage = () => {
            getLanguages(null, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { languages = [] } = res.info || [];
                const userLanguage = languages.find(item => (item === null || item === void 0 ? void 0 : item.language_code) === Constant.language) || {};
                this.setState({
                    userLanguage,
                    languages
                });
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.getCurrency = () => {
            getCurrencies(null, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { currencies = [], new_currencies = [] } = res.info || {};
                let currencyList = [];
                if (new_currencies && new_currencies.length > 0) {
                    currencyList = new_currencies;
                }
                else {
                    currencyList = currencies;
                }
                const userCurrency = currencyList.find(item => (item === null || item === void 0 ? void 0 : item.currency_code) === Constant.currency) || {};
                this.setState({
                    userCurrency,
                    currencies: currencyList
                });
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.getAppLowpriceCountry = () => {
            const ATTRNAME_KEY = "APP_LOWPRICE_COUNTRY";
            getInfo({ namespace: "LITB.OTHER.COUNTRIES", attrName: ATTRNAME_KEY }, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { value = {} } = res.info || {};
                const keyValue = value[ATTRNAME_KEY] || "";
                if ((Constant === null || Constant === void 0 ? void 0 : Constant.countryId) && keyValue.split(",").includes(Constant.countryId)) {
                    this.getAppLowPriceTextContent();
                }
            })
                .catch(err => {
                console.warn(err);
            });
        };
        this.getAppLowPriceTextContent = () => {
            const ATTRNAME_KEY = "DEFAULT.TXT_MOBILE_ENTRANCE_NEW";
            getInfo({ namespace: "LITB.LANG.VELA", attrName: ATTRNAME_KEY, nsLanguageCode: Constant.language }, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { value = {} } = res.info || {};
                this.setState({ lowPriceCountryPriceOff: value[ATTRNAME_KEY] || "" });
            })
                .catch(err => {
                console.warn(err);
            });
        };
    }
    componentDidMount() {
        if (Constant.isLogin) {
            this.getUser();
        }
        this.getAppLowpriceCountry();
        this.getCart();
        this.getCountry();
        this.getCurrency();
        this.getLanguage();
    }
    render() {
        const { userName, cart, countries = [], topCountries = [], userCountry, currencies, userCurrency, languages = [], userLanguage, lowPriceCountryPriceOff } = this.state;
        return (React.createElement(Header, null,
            React.createElement(HeaderContainer, null,
                React.createElement(HeaderNav, { countries: countries, popularCounties: topCountries, userCountry: userCountry, currencies: currencies, userCurrency: userCurrency, languages: languages, userLanguage: userLanguage, onChangeLanguage: this.props.onChangeLanguage, lowPriceCountryPriceOff: lowPriceCountryPriceOff }),
                React.createElement(HeaderPageLet, { cart: cart, userName: userName }))));
    }
}
export default WebHeader;
